import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41b2510d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-p-[24px] lg:tw-p-[40px] tw-flex tw-flex-col tw-bg-[#FFF]" }
const _hoisted_2 = { class: "tw-flex tw-gap-[26px] tw-flex-col md:tw-flex-row tw-flex-wrap" }
const _hoisted_3 = { class: "tw-mb-[14px]" }
const _hoisted_4 = { class: "tw-text-[#211F58] tw-text-[15px] tw-font-medium" }
const _hoisted_5 = { class: "tw-text-[#878787] tw-text-[13px] tw-font-normal tw-text-center" }
const _hoisted_6 = {
  key: 0,
  class: "create-new-ass-modal-note"
}
const _hoisted_7 = { class: "tw-cursor-pointer tw-p-[16px] lg:tw-px-[30px] tw-flex-1 tw-h-[347px] tw-flex tw-flex-col tw-items-center tw-gap-5 tw-bg-[#F2F8FF] tw-rounded-[4px]" }
const _hoisted_8 = { class: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2" }
const _hoisted_9 = { class: "tw-text-[#211F58] tw-text-[15px] tw-font-medium" }
const _hoisted_10 = { class: "tw-text-[#878787] tw-text-[13px] tw-font-normal tw-text-center" }
const _hoisted_11 = { class: "tw-w-[100%] tw-flex tw-justify-center" }
const _hoisted_12 = {
  class: /*#__PURE__*/_normalizeClass(`tw-flex tw-mt-10 sm:tw-flex-row tw-justify-between tw-gap-[15px] sm:tw-gap-[0px]`)
}

import { getComponentUiText } from "@/utils/utilities";
import { computed, ref, watch } from "vue";
import AddNewTemplateIcon from "../svgs/addNewTemplateIcon.vue";
import AddNewTemplateIcon2 from "../svgs/addNewTemplateIcon2.vue";
import BaseDropDown from "../common/form/baseDropDown.vue";
import router from "@/router";
import store from "@/store";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import InfoIcon from "../svgs/infoIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'createVendorAssessmentModal',
  props: {
  show: {
    type: Boolean,
    required: true,
  },
  maxWidth: {
    type: Number,
    required: false,
    default: 65,
  },
  isShowWarning: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: [
  "update:show",
  "update:close",
  "update:templateId",
  "update:selection",
],
  setup(__props, { emit }) {

const props = __props;



let showRef = ref(props.show);
const data = ref("");
const form = ref({
  data: "",
});

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

watch(
  () => form.value.data,
  (value) => {
    if (value) {
      emit("update:selection", value);
    }
  },
);

const existingTemplateData = computed(() =>
  store.state.Vendor.checklistRequestedTemplate
    .filter((item) => item.itemCount > 0)
    .map((item) => ({
      ...item,
      id: item.templateId,
      name: item.templateName,
    })),
);

const openModalCreateNewVendorAssessment = async (item) => {
  await v$.value.$validate();
  if (v$.value.$invalid) return;
  emit("update:templateId", item);
};



const handleCloseModal = (isCancel = false) => {
  showRef.value = false;
  emit("update:show", showRef.value);
  emit("update:close", isCancel);
};

const handleCreateNewTemplate = () => {
  store.commit("Vendor/SET_CHECKLIST_REQUESTED_TEMPLATE_DETAIL_BY_ID", []);
  router.push({ path: "/assess/vendor/template" });
  handleCloseModal();
};

const rules = {
  data: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
};
const v$ = useVuelidate(rules, form as any);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        "data-cy": "vendor-assess-modal-create-new-assess-create-new-template-btn",
        class: _normalizeClass(`tw-cursor-pointer tw-pt-[22px] tw-pb-[16px] tw-px-[16px] lg:tw-px-[30px] tw-flex-1 tw-h-[347px] tw-flex tw-flex-col tw-items-center tw-bg-[#F2F8FF] tw-rounded-[4px] ${
          !__props.isShowWarning ? 'tw-justify-center' : ''
        }`),
        onClick: handleCreateNewTemplate
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(AddNewTemplateIcon)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(`tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 ${
            __props.isShowWarning ? 'tw-mb-[20px]' : ''
          }`)
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(getComponentUiText)(
                "app-modal-create-a-new-vendor-assessment-title-create-a-new-template-to-use-1",
              )), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(getComponentUiText)(
                "app-modal-create-a-new-vendor-assessment-description-create-a-new-template-to-use-1",
              )), 1)
        ], 2),
        (__props.isShowWarning)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(InfoIcon),
              _createTextVNode(" " + _toDisplayString(_unref(getComponentUiText)("app-vendor-assessment-create-new-note-1")), 1)
            ]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, [
          _createVNode(AddNewTemplateIcon2)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(getComponentUiText)(
                "app-modal-create-a-new-vendor-assessment-title-use-an-existing-template-1",
              )), 1),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(getComponentUiText)(
                "app-modal-create-a-new-vendor-assessment-description-use-an-existing-template-1",
              )), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(BaseDropDown, {
            id: 'preferredLanguage',
            modelValue: form.value.data,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.data) = $event)),
            data: existingTemplateData.value,
            "data-cy-id": "existing-template-dropdown",
            "class-name": 'gray-dropdown-container tw-h-[58px]',
            placeholder: 
              _unref(getComponentUiText)(
                'app-vendor-dropdown-placehoder-choose-template-1',
              )
            ,
            validation: _unref(v$).data,
            "show-validate": true,
            "is-option-button-dropdown": true,
            "text-option-button-dropdown": 
              _unref(getComponentUiText)(
                'app-vendor-create-a--new-assessment-option-dropdown-1',
              )
            ,
            "bg-dropdown": '#FFF',
            "custom-select-container": 'tw-text-[15px] tw-font-medium tw-leading-[15px]'
          }, null, 8, ["modelValue", "data", "placeholder", "validation", "text-option-button-dropdown"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("button", {
        class: "tw-border-[#F7553C] hover:tw-bg-[#F7553C] hover:tw-text-white tw-border-solid tw-border-[2px] tw-w-fit tw-shadow-none tw-bg-[#fff] tw-text-[#F7553C] tw-py-[8px] tw-px-[20px] tw-text-[13px] tw-font-medium tw-rounded-[27px] tw-leading-normal",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleCloseModal(true)))
      }, _toDisplayString(_unref(getComponentUiText)(
            "app-menu-submenu-home-setup-wizard-modal-button-cancel-1",
          )), 1),
      _createElementVNode("button", {
        "data-cy": "go-btn",
        class: "tw-ml-[15px] tw-text-[#fff] tw-bg-[#387DFF] hover:tw-bg-[#0069d9] tw-py-[8px] tw-px-[20px] tw-text-[13px] tw-rounded-[27px] tw-leading-normal tw-font-medium tw-border-[#387DFF] tw-border-solid tw-border-[2px]",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (openModalCreateNewVendorAssessment(form.value.data)))
      }, _toDisplayString(_unref(getComponentUiText)(
            "app-modal-create-a-new-vendor-assessment-btn-go-1",
          )), 1)
    ])
  ]))
}
}

})